$(document).ready(function() {
  var viewedProducts = JSON.parse(localStorage.getItem('viewed_products')) || [];
  console.log(viewedProducts, 'recent_products');
  if(viewedProducts.length > 0){
      $('.recnetly_view_title').show();
      }
  var html = '';
  for (var i = 0; i < viewedProducts.length; i++) {
    if(i < 4){
      if (viewedProducts[i].img) {
      html += '<div class="featured-collection-grid__product carousel_slide swiper-slide">'+
'<div class="product-item animation animation--item">'+
        '<div class="product-item__inner">'+
            '<div class="product-item__media product-item__media--multiple-images">'+
                '<a class="product-item__image-link" href="' + viewedProducts[i].url + '">'+
      '<div class="image product-item__image product-item__image--one aspect-ratio--portrait animation--lazy-load loaded" style="--object-fit: cover;">'+
                       ' <div class="image__inner">'+
                           ' <img alt="" class="image__img" loading="lazy" width="899" height="1348" src="' + viewedProducts[i].img + '"  sizes="(max-width: 720px) calc((90vw - 12px) / 2), (max-width: 1400px) calc((93.4vw - (12px * 3)) / 4), 304px">'+
                        '</div>'+
                             '</div>'+
                    '<div class="image product-item__image product-item__image--two aspect-ratio--portrait loaded" style="--object-fit: cover;">'+
                        '<div class="image__inner">'+
                            '<img alt="" class="image__img" loading="lazy" width="882" height="1323" src="' + viewedProducts[i].hoverImage + '"  sizes="(max-width: 720px) calc((90vw - 12px) / 2), (max-width: 1400px) calc((93.4vw - (12px * 3)) / 4), 304px">'+
                        '</div>'+
                    '</div>'+
                '</a>'+
            '</div>'+
            '<div class="product-item__meta">'+
                '<div class="product-item__text ta-c ">'+
                    '<h4 class="ff-body product-item__product-title fs-product-card-title"><a href="' + viewedProducts[i].url + '">' + viewedProducts[i].title + '</a></h4>'+
                   '<p class="product-item__price">'+
                        '<span class="product-item__price">' + viewedProducts[i].price + '</span>'+
                    '</p>'+
        '</div>'+
    '</div>'+
'</div>'+
'</div>'+
'</div>';
    }
    }
  }

  // console.log(html, $('#recently-viewed'));
  
 // Append the HTML after a delay of 1 second
setTimeout(function() {
    $('#recently-viewed').append(html);
}, 1000); // 1000 milliseconds = 1 second

    $('#recently-viewed-section').append(html);
});

$(document).on('click', '.product-item__image-link', function(e) {
  var productId = $(this).data('product-id');
  var productTitle = $(this).data('title');
   var productImage = $(this).data('img');
   var productHoverImage = $(this).data('hover-img');
   var productPrice = $(this).data('price');
  var productUrl = $(this).attr('href');
  var viewedProducts = JSON.parse(localStorage.getItem('viewed_products')) || [];
  var existingProductIndex = viewedProducts.findIndex(function(product) {
    return product.id === productId;
  });
  if (existingProductIndex !== -1) {
    viewedProducts.splice(existingProductIndex, 1);
  }
  viewedProducts.unshift({
    id: productId,
    title: productTitle,
    url: productUrl,
   img: productImage,
    hoverImage: productHoverImage,
    price: productPrice
  });
  localStorage.setItem('viewed_products', JSON.stringify(viewedProducts));
});
